/* unplugin-vue-components disabled */import script from "./add.vue?vue&type=script&lang=ts&setup=true"
export * from "./add.vue?vue&type=script&lang=ts&setup=true"

import "./add.vue?vue&type=style&index=0&id=8870648c&scoped=true&lang=less"

import exportComponent from "E:\\projects\\front\\ysdp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8870648c"]])

export default __exports__